export default "__VITE_ASSET__btfsbxyH__"